'use client';

import {lazy, Suspense} from 'react';
import 'swiper/css';

import {ArticleType, SimilarArticles} from '@strapi/types/Articles';

import styles from './ArticlesList.module.scss';
import ArticleView from './ArticleView';

const LazySwiper = lazy(() => import('./ArticlesSwiper'));

type Props = {
  similar: SimilarArticles;
  articleUrl: string;
  onSimilarArticleClick?: (article: ArticleType) => void;
};

const Placeholder = ({similar, articleUrl, onSimilarArticleClick}: Props) => {
  return (
    <div className={styles.placeholder}>
      {similar.articles.map((article) => (
        <ArticleView
          key={article.id}
          article={article}
          articleUrl={articleUrl}
          onSimilarArticleClick={onSimilarArticleClick}
        />
      ))}
    </div>
  );
};

export default function ArticlesList({
  similar,
  articleUrl,
  onSimilarArticleClick,
}: Props) {
  return (
    <Suspense
      fallback={<Placeholder similar={similar} articleUrl={articleUrl} />}
    >
      <LazySwiper similar={similar} articleUrl={articleUrl} />
    </Suspense>
  );
}
